import { Component, OnInit } from '@angular/core';
import { ColumnHeader } from 'src/app/models/column-header';
import { Labels } from'src/app/constants/labels';
import { FormGroup, FormBuilder, FormArray, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PageDetails } from 'src/app/models/page-details';
import { CommonService } from 'src/app/services/common-service/common.service';
import { KEYS } from'src/app/constants/keys';
import { isData, isPresent } from 'src/app/utils/utils';
import { LayoutArrayData } from 'src/app/models/layout-array-data';
import { forkJoin } from 'rxjs';
import { RoutePath } from'src/app/constants/routerPath';
import { PageWorkflowComponent } from 'src/app/components/modal/page-workflow/page-workflow.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ColumnHeaderComponent } from 'src/app/components/column-header/column-header.component';
import { AdminTopbuttonLayoutComponent } from 'src/app/components/admin-topbutton-layout/admin-topbutton-layout.component';
import { AdminLayoutComponent } from 'src/app/components/admin-layout/admin-layout.component';

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss'],
  imports:[ReactiveFormsModule,ColumnHeaderComponent,AdminTopbuttonLayoutComponent,AdminLayoutComponent]
})
export class AdminPageComponent implements OnInit {
  headerData: ColumnHeader | any;
  layoutForm: FormGroup | any;
  form: FormGroup | any;
  // layoutPanel: Array<PanelData>;
  topButtonLayout: boolean | any;
  buttonLabel = Labels.buttons;
  pageLabel = Labels.page;
  pageId: any = '';
  pageName: any = '';
  tableName: any = '';
  parentMenuId: any = '';

  pageDetails: PageDetails | any;
  routePath = RoutePath;
  layoutArray: Array<LayoutArrayData> | any;
  commonLayoutArray: any;
  bsModalRef!: BsModalRef;
  isSuperaDmin: boolean = false;
  dbPath: any;
  labelPageWorkflow = Labels.pageWorkflow;
  allControls: any = [];
  constructor(private fromBuilder: FormBuilder,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private router: Router,
    public modalService: BsModalService,
    private _location: Location) { }

  ngOnInit(): void {
    this.isSuperAdmin();
    this.pageDetails = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!);
    // console.log('pageDetails : ', this.pageDetails);
    this.initHeaderComponent(this.pageDetails.pageName);
    this.loadLayout(this.pageDetails.pageId);
    this.initForms();
  }
  isSuperAdmin() {
    this.isSuperaDmin = JSON.parse(sessionStorage.getItem(KEYS.isSuperAdmin)!);
    if (this.isSuperaDmin) {
      this.dbPath = JSON.parse(sessionStorage.getItem(KEYS.customerDbPath)!);
    }
  }
  loadAuditTrial() {
    sessionStorage.setItem('ifpopup', '0');
    this.pageDetails = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!);
    this.router.navigate([this.routePath.auditTrialPageAdmin], { queryParams: { pageId: this.pageDetails.pageId, controlId: 0, fromPage: 0 } });
  }

  setPageWorkflow() {
    const config: ModalOptions = { class: KEYS.modalConfigClass, backdrop: "static", animated: true, }
    this.bsModalRef = this.modalService.show(PageWorkflowComponent, config);
    this.bsModalRef.content.data = {
      title: this.labelPageWorkflow.title
    }

  }

  loadAllControls(pageID: any) {
    let gridControlsAPI
    let controlsAPI;
    let tabControlAPI;
    if (this.isSuperaDmin) {
      controlsAPI = this.commonService.getAllControlsForSuperAdmin(this.dbPath, pageID);
      gridControlsAPI = this.commonService.getLayoutControlsForSuperAdmin(
        this.dbPath,
        this.commonService.getUserCredentials(KEYS.credential_customer_id),
        KEYS.appId.defaultID,
        pageID);
      tabControlAPI = this.commonService.getTabDetailsFromAdmin(this.dbPath, pageID);
    } else {
      controlsAPI = this.commonService.getAllControls(pageID);
      gridControlsAPI = this.commonService.getLayoutControls(
        this.commonService.getUserCredentials(KEYS.credential_customer_id),
        KEYS.appId.defaultID,
        pageID);
      tabControlAPI = this.commonService.getTabDetailsFromAdmin('', pageID);
    }

    forkJoin([controlsAPI, gridControlsAPI, tabControlAPI]).subscribe((data: any) => {
      if (data.length > 0) {
        let mergeData: any = [];
        data.forEach((element: any) => {
          element['table'].forEach((table: any) => {
            mergeData.push(table);
          });
        });
        this.filterAllControls(mergeData);
      } else {
        console.log('load all controls : No data found ', data);
      }
    }, error => {
      console.log('load all controls error : ', error);
    })
  }

  filterAllControls(data: any) {
    console.log('data***:', data);
    let arrayInfo = this.commonService.layoutArrayInfo;
    arrayInfo.forEach((layoutEle, key) => {
      for (let index = 0; index < layoutEle.layoutData; index++) {
        if (layoutEle.layoutType == KEYS.layoutType.CLayout) {
          arrayInfo[key].layoutControls.push([]);
        }
      }
    });
    data.forEach((controlEle: any) => {
      arrayInfo.forEach((layoutEle, key) => {
        if (layoutEle.layoutID == controlEle.gstibo_layout_id) {
          // console.log('controlEle:', controlEle);
          if (layoutEle.layoutType == KEYS.layoutType.CLayout) {
            arrayInfo[key].layoutControls[controlEle.gstibo_layout_sub_id - 1].push(controlEle);
          } else {
            arrayInfo[key].layoutControls.push(controlEle);
          }
        }
      });
    });
    this.allControls = [];
    this.commonService.setLayoutArrayInfo(arrayInfo);
    this.commonService.setControlLayoutData(arrayInfo);
    arrayInfo.forEach(control => {
      if (control.layoutType == "COMMON_LAYOUT") {
        control.layoutControls.forEach(inputs => {
          inputs.forEach((row: any) => {
            this.allControls.push({
              'inputid': row.gstibo_input_textbox_id,
              'label': row.gstibo_input_label
            });
          });
        });
      }
    });
    this.commonService.setControlsForPageWorkflow(this.allControls);
    console.log('this.allControls:', this.allControls);
  }

  private initHeaderComponent(pageName: any) {
    // this.route.queryParams.subscribe(params => {
    //   this.pageId = params['pageId'];
    //   this.pageName = params['pageName'];
    //   this.tableName = params['tableName'];
    //   this.parentMenuId = params['parentMenuId'];
    // });

    this.headerData = {
      title: pageName,
      button: {
        show: false,
      },
      topButton: {
        show: false
      }
    };
  }

  private initForms() {
    this.layoutForm = this.fromBuilder.group({
      layout: ['1']
    });

    this.form = this.fromBuilder.group({
      commonLayout: this.fromBuilder.array([])
    });
  }


  loadLayout(pageId: any) {
    if (this.isSuperaDmin) {
      this.commonService.getLayoutForSuperAdmin(this.dbPath, this.commonService.getUserCredentials(KEYS.credential_account_id), pageId).subscribe((res: any) => {
        console.log('loadLayout : ', res);
        const _key = res['table'];
        let layoutbgColor;
        this.layoutArray = [];
        if (isData(res)) {
          _key.forEach((element: any) => {
            let layoutWidth;
            if (isPresent(element.gstibo_layout_width)) {
              layoutWidth = element.gstibo_layout_width;
            }
            else {
              const lWidth = (100 / Number(element.gstibo_layout_data));
              let widthString = "";
              let layoutCount = 0;
              while (layoutCount < Number(element.gstibo_layout_data)) {
                widthString += lWidth + '|';
                layoutCount++;
              }
              widthString = widthString.substring(0, widthString.length - 1);
              layoutWidth = widthString;
            }
            layoutbgColor = isPresent(element.gstibo_layout_color) ? element.gstibo_layout_color : '';
            this.layoutArray.push({
              layoutID: element.gstibo_layout_id,
              layoutData: Number(element.gstibo_layout_data),
              layoutHeight: element.gstibo_layout_height,
              layoutType: Number(element.gstibo_layout_data) == 6 ? KEYS.layoutType.TBLayout : KEYS.layoutType.CLayout,
              layoutControls: [],
              layoutWidth: layoutWidth,
              layoutIsTab: element.gstibo_layout_is_tab,
              layoutTabHeadings: element.gstibo_layout_tab_heading,
              layoutbgColor: layoutbgColor
            });
          });
        }

        this.commonService.setLayoutArrayInfo(this.layoutArray);
        this.layoutArray.forEach((element: any) => {
          this.addLayoutRow(element['layoutData']);
        });
        this.commonLayoutArray = this.layoutArray.filter((x: any) => x.layoutType == KEYS.layoutType.CLayout);

        this.loadAllControls(this.pageDetails.pageId);
      });
    } else {
      this.commonService.getLayout(this.commonService.getUserCredentials(KEYS.credential_account_id), pageId).subscribe((res: any) => {
        // console.log('loadLayout : ', res);
        const _key = res['table'];
        let layoutbgColor;
        this.layoutArray = [];
        if (isData(res)) {
          _key.forEach((element: any) => {
            let layoutWidth;
            if (isPresent(element.gstibo_layout_width)) {
              layoutWidth = element.gstibo_layout_width;
            }
            else {
              const lWidth = (100 / Number(element.gstibo_layout_data));
              let widthString = "";
              let layoutCount = 0;
              while (layoutCount < Number(element.gstibo_layout_data)) {
                widthString += lWidth + '|';
                layoutCount++;
              }
              widthString = widthString.substring(0, widthString.length - 1);
              layoutWidth = widthString;
            }
            (isPresent(element.gstibo_layout_width) ? element.gstibo_layout_width : '');
            layoutbgColor = isPresent(element.gstibo_layout_color) ? element.gstibo_layout_color : '';
            this.layoutArray.push({
              layoutID: element.gstibo_layout_id,
              layoutData: Number(element.gstibo_layout_data),
              layoutHeight: element.gstibo_layout_height,
              layoutType: Number(element.gstibo_layout_data) == 6 ? KEYS.layoutType.TBLayout : KEYS.layoutType.CLayout,
              layoutControls: [],
              layoutWidth: layoutWidth,
              layoutIsTab: element.gstibo_layout_is_tab,
              layoutTabHeadings: element.gstibo_layout_tab_heading,
              layoutbgColor: layoutbgColor

            });
          });
        }

        this.commonService.setLayoutArrayInfo(this.layoutArray);
        this.layoutArray.forEach((element: any) => {
          this.addLayoutRow(element['layoutData']);
        });
        this.commonLayoutArray = this.layoutArray.filter((x: any) => x.layoutType == KEYS.layoutType.CLayout);
        this.loadAllControls(this.pageDetails.pageId);
      });
    }

  }

  addLayoutRow(layoutData: number = 0) {
    // console.log('addLayoutRow : ', this.layoutForm.value);
    const noOfLayout = layoutData > 0 ? layoutData : Number(this.layoutForm.value.layout);
    if (noOfLayout == 6) {
      if (layoutData > 0) {
        this.addTopButtonLayout();
      } else {
        this.addLayoutManually(noOfLayout);
      }
    } else {
      if (layoutData > 0) {
        this.addCommonLayout(noOfLayout);
      } else {
        this.addLayoutManually(noOfLayout);
      }
    }
    // console.log('layoutPanel : ', this.layoutPanel);
    // console.log('masterForm : ', this.form.value);
  }

  addLayoutManually(panelCount: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.addLayout(
      dbFullPath,
      panelCount,
      this.pageDetails.pageId,
      this.commonService.getUserCredentials(KEYS.credential_account_id)
    ).subscribe((data: any) => {
      // console.log('data : ', data);
      this.ngOnInit();
    },
      error => {
        console.log('add new layout Error:', error);
      }
    );
  }

  addCommonLayout(panelCount: any) {
    const commonArr = this.form.controls.commonLayout as FormArray;
    commonArr.push(this.fromBuilder.array([]));

    const layoutArray = this.form.controls.commonLayout as FormArray;
    const specificLayoutArray = layoutArray.controls[layoutArray.value.length - 1] as FormArray;

    for (let index = 0; index < panelCount; index++) {
      specificLayoutArray.push(this.fromBuilder.array([]));
    }
    // console.log(this.commonService.layoutArrayInfo);

  }

  addTopButtonLayout() {
    this.form.addControl('topButtonLayout', this.fromBuilder.array([]));
  }
  backButtonClick() {
    this._location.back();
  }
}

